const NavItems = ['Home', 'Projects', 'About', 'Contact']

export default NavItems